import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { LocalStorageServiceProvider } from '../../providers/local-storage-service/local-storage-service';
import { ServerProvider } from '../../providers/server/server';
import { AlertController } from 'ionic-angular';


@Component({
    selector: 'page-category',
    templateUrl: 'category.html',
})
export class CategoryPage {

    categories = []

    constructor(public navCtrl: NavController, public navParams: NavParams,
        public localStorage: LocalStorageServiceProvider, public server: ServerProvider,
        public alertCtrl: AlertController) {
        this.categories = localStorage.getCategories()
        localStorage.fetchCategories()
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad CategoryPage');
    }

    addCategory() {
        let prompt = this.alertCtrl.create({
            title: 'Neue Kategorie',
            message: "Bitte geben Sie den Namen der neu zu erstellenden Kategorie an",
            inputs: [
                {
                    name: 'name',
                    placeholder: 'Name'
                },
            ],
            buttons: [
                {
                    text: 'Abbrechen',
                    handler: data => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Speichern',
                    handler: data => {
                        console.log('Saved clicked');
                        this.server.createCategory(data.name).subscribe(
                            data=>{
                                this.categories.push(data.json())
                            },
                            error=>{
                                console.error("Failed to create category")
                            }
                        )
                    }
                }
            ]
        });
        prompt.present();
    }

    deleteCategory(category_id, idx, slidingItem) {
        this.server.deleteCategory(category_id).subscribe(
            data => {
                this.categories.splice(idx, 1)
            },
            error => {
                console.error(error)
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/category/category.ts